import React, { useState, useEffect } from "react";
import Map from "./components/graph/Map";
import HomePreviewDash from "./components/HomePreviewDash";
import axios from "axios";
import { Utils } from "./Utils";

function Home() {
  const [markers, setMarkers] = useState<any>([]);
  const [currentStation, setCurrentStation] = useState<any>();

  useEffect(() => {
    axios
      .get(Utils.BACKEND_BASE_URL + "station")
      .then((res) => setMarkers(res.data))
      .catch((err) => console.error("unable to fetch stations", err));
  }, []);

  const handleMarker = (c: string) => {
    setCurrentStation(markers[parseInt(c)]);
  };

  return (
    <div className="space-y-6">
      {markers.length > 0 && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Map */}
          <div className="lg:col-span-2">
            <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-100 h-[400px] md:h-[500px]">
              <Map
                markers={markers}
                onMarkerSelection={(c) => handleMarker(c)}
              />
            </div>
          </div>
          {/* Monitoring panel */}
          <div className="lg:col-span-1">
            <div className="rounded-xl bg-white p-5 shadow-sm border border-gray-100 flex flex-col md:h-[500px]">
              <h3 className="text-base font-semibold text-gray-800 mb-3">
                Monitoring area{" "}
                <span className="uppercase text-brand-400">
                  {currentStation?.name}
                </span>
              </h3>
              {currentStation ? (
                <>
                  <div className="flex-1 min-h-0 overflow-y-auto">
                    <HomePreviewDash station={currentStation} />
                  </div>
                  <div className="mt-4 text-center shrink-0">
                    <a
                      href={"/station/" + currentStation._id}
                      className="inline-block rounded-lg bg-brand-300 px-6 py-2 text-sm font-semibold text-white uppercase tracking-wide hover:bg-brand-400 transition"
                    >
                      Go to station
                    </a>
                  </div>
                </>
              ) : (
                <p className="text-sm text-gray-400 italic mt-8 text-center">
                  Select a station on the map
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Project info */}
      <div className="rounded-xl bg-white p-6 shadow-sm border border-gray-100">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">ALTRUIST Project</h2>
        <p className="text-sm text-gray-600 leading-relaxed">
          totAL variomeTry foR tsUnamI hazard eStimaTion project through{" "}
          <b>GNSS VarioPy</b> for AXA-UNESCO funded project.
          <br />
          @ Geodesy and Geomatics division —{" "}
          <em>Sapienza University of Rome</em>
        </p>
      </div>
    </div>
  );
}

export default Home;
